import React from 'react';

var StoreLocation10 = function StoreLocation10(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.354 21.48a2.014 2.014 0 0 1-2.846-.138C6.186 16.58 4 12.847 4 10c0-4.513 3.536-8 8-8s8 3.487 8 8c0 2.847-2.186 6.58-6.508 11.342-.044.049-.09.095-.138.138zM18 10c0-3.402-2.634-6-6-6s-6 2.598-6 6c0 2.2 1.98 5.58 5.99 9.998C16.02 15.58 18 12.2 18 10zM9.677 7.696h.796c.158 0 .208.034.208.183v4.175h.78V13h-3.08v-.946h.856V9.157l-.581.34c-.1.059-.175.05-.224-.041L8 8.709l1.677-1.013zm6.357 2.681c0 1.644-.622 2.723-2.116 2.723-1.494 0-2.133-1.08-2.133-2.723 0-1.643.63-2.73 2.125-2.73 1.494 0 2.124 1.087 2.124 2.73zm-1.51 0c0-1.195-.166-1.643-.614-1.643-.449 0-.615.448-.615 1.643s.175 1.635.623 1.635.606-.44.606-1.635z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

StoreLocation10.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { StoreLocation10 as icon };
export default iconHandler(StoreLocation10);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/StoreLocation10.js
// module id = 626
// module chunks = 0